import { request } from "../../api/api";

export const getExtruder = (id) => {
  return request.get(`/packing/getExtruderList/?plant_id=${id}`);
};
export const getShift = (selectedPlantData) => {
  return request.get(`/packing/getShift/?plant_id=${selectedPlantData}`);
};
export const previewData = (data) => {
  return request.post("/packing/getLabelPreviewData", data);
};
export const getPackingHistory = (selectedPlantData) => {
  return request.get(
    `/packing/getLastPackingHistory/?plant_id=${selectedPlantData}`
  );
};

export const getPrinter = (plant_id, extruder_id) => {
  return request.get(
    `/packing/getPrinter/?plant_id=${plant_id}&extruder_id=${extruder_id}`
  );
};

export const printPackingDetails = (data) => {
    return request.post("/packing/printPackingDetails/", data);
  };

export const getPackingHistoryData = (searchParams) => {
  let queryParams = [
    searchParams.search.created_at
      ? `search=${searchParams.search.created_at}`
      : "",
    searchParams.search.batch_no
      ? `batch_no=${searchParams.search.batch_no}`
      : "",
    searchParams.search.product__product_name
      ? `&product__product_name=${searchParams.search.product__product_name}`
      : "",
    searchParams.search.plant__name
      ? `plant__name=${searchParams.search.plant__name}`
      : "",
    searchParams.search.shift__shift_name
      ? `shift__shift_name=${searchParams.search.shift__shift_name}`
      : "",
    searchParams.search.size__size
      ? `size__size=${searchParams.search.size__size}`
      : "",
    searchParams.search.extruder__name
      ? `extruder__name=${parseInt(searchParams.search.extruder__name)}`
      : "",
    searchParams.search.printer__name
      ? `printer__name=${searchParams.search.printer__name}`
      : "",
    searchParams.search.line ? `line=${searchParams.search.line}` : "",
    searchParams.search.quantity
      ? `quantity=${searchParams.search.quantity}`
      : "",
    searchParams.search.created_by__email
      ? `created_by__email=${searchParams.search.created_by__email}`
      : "",
    searchParams.search.created_at__date
      ? `created_at__date=${searchParams.search.created_at__date}`
      : "",
      searchParams.search.pack_no
      ? `pack_no=${searchParams.search.pack_no}`
      : "",
      searchParams.search.no_of_prints
      ? `no_of_prints=${searchParams.search.no_of_prints}`
      : "",
      
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/packing/getPackingHistory/?${queryParams}&${
      searchParams.rowsPerPage ? `page_size=${searchParams.rowsPerPage}` : ""
    }&page=${searchParams.page + 1}`
  );
};

export const LabelPreview = (params) => {
    return request.post('/packing/getLabelPreviewData/', params);
}
export const createPacking =(params) =>{
  return request.post('/packing/createPacking/', params);
}